import { googleLogout } from '@react-oauth/google';
import { useMainContext } from 'context/MainContext';
import React, { useCallback } from 'react';
import api from 'services/api';
import * as S from './styles';

const Logout: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className
}) => {
  const { setProfile, setShowMenu } = useMainContext();

  const handleLogout = useCallback(() => {
    api.defaults.headers.common.Authorization = '';
    sessionStorage.clear();
    googleLogout();
    setShowMenu(false);
    setProfile(null);
    console.log('usuário deslogado com sucesso');
  }, [setProfile, setShowMenu]);

  return (
    <S.Container className={className} onClick={handleLogout}>
      <S.LogoutICon />
      <span>Sair</span>
    </S.Container>
  );
};

export default Logout;
